// extracted by mini-css-extract-plugin
export default {"label":"SliderLabel_label__k1Oxw"};